import React from 'react';
import { Image } from 'semantic-ui-react';
import { Loader } from '../Loaders';

const BuilderInfoLoader = () => (
  <Loader>
    <Image
      src="/images/loader.png"
      style={{ width: '100%', height: '200px' }}
    />
  </Loader>
);

export default BuilderInfoLoader;
